import { init as initFullStory } from "@fullstory/browser";
import "phoenix_html";
import { UAParser } from "ua-parser-js";
import { fetchMetaData } from "./fetchMetaData";
import { initColorScheme } from "./util/colorScheme";

initColorScheme();

document.addEventListener("DOMContentLoaded", () => {
  const fullStoryOrgId = fetchMetaData("fullStoryOrgId");
  if (fullStoryOrgId !== null) {
    initFullStory({ orgId: fullStoryOrgId });
  }

  const linksList = document.querySelector("#authenticator-links");
  if (linksList !== null) {
    const browserOS = new UAParser().getOS();
    if (browserOS.name === "Android") {
      const iOSLink = linksList.querySelector("#authenticator-link-ios");
      iOSLink?.remove();
    } else if (browserOS.name === "iOS") {
      const androidLink = linksList.querySelector(
        "#authenticator-link-android",
      );
      androidLink?.remove();
    }
  }
});
